import React, { FC, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectPhaseMap } from 'api/project';
import { StatusFieldOption } from 'api/tasks';
import { PhaseProgress } from 'components/molecules/phase-progress';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { StatusPopover } from 'components/molecules/status-popover/index';
import { status } from '../constants';

const Flex = styled.div`
  display: flex;
`;

const PopoverStatus = styled.div`
  display: flex;
  align-items: center;
  margin: var(--spacing-03) auto;
`;

const StatusText = styled.p`
  margin: var(--spacing-01) var(--spacing-03);
  line-height: var(--spacing-05);
`;

const PercentText = styled(StatusText)`
  &::before {
    content: '.';
    position: absolute;
    margin-left: calc(-1 * var(--spacing-04));
    padding: var(--spacing-02);
    line-height: var(--spacing-01);
  }
`;

/**
 * @description get the tooltip content, with status, phase name and percentage
 * @param data
 */
const getTooltipContent = (data: ProjectPhaseMap[]): ReactElement[] => {
  if (data) {
    return data.map((phase: ProjectPhaseMap) => {
      const percent = Math.floor((phase.completed / phase.total) * 100) || 0;

      const derivedStatus: StatusFieldOption = phase.status ?? status[1];

      return (
        <PopoverStatus key={`${phase.name}_${status.group}`}>
          <StatusIndicator status={derivedStatus} progress={percent} />
          <StatusText data-cy="phase.name">{phase.name}</StatusText>
          <PercentText data-cy="phase.percentage">
            <FormattedMessage id="percentage" values={{ percent }} />
          </PercentText>
        </PopoverStatus>
      );
    });
  }

  return [];
};

export const Phases: FC<{
  title?: string | any;
  subTitle?: string;
  phases: ProjectPhaseMap[];
}> = ({ title, subTitle, phases }): ReactElement => {
  const content = getTooltipContent(phases);

  return (
    <StatusPopover title={title} subTitle={subTitle} content={content}>
      <Flex>
        <PhaseProgress phaseData={phases} />
      </Flex>
    </StatusPopover>
  );
};
